import { MapfreIconComponent } from '../mapfre-icon/mapfre-icon.component';
import { MapfreButtonComponent } from '../inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { AlertService } from "../../../_services/alert.service";
import { AcmicService } from "../../../_services/acmic.service";
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule, MapfreButtonComponent, MapfreIconComponent],
  selector: 'mapfre-alert',
  templateUrl: './mapfre-alert.component.html'
})
export class MapfreAlertComponent implements OnInit {
  @Input()  additionalClasses = '';
  @Input()  alertType = 'default';
  @Input()  nonDynamic = false;
  @Input()  notTop = true;
  @Input()  loginPage = false;
  @Input()  closeButton = false;
            closeFadeIn:          boolean;
            closeFadeOut = false;
            setFadeOut = true;
            message:              any;
            isAcmic = false;
            showWanringIcon = false;

  @Output() hide:                 EventEmitter<boolean> = new EventEmitter();
  manageWallet = false;

  constructor(
    private alertService: AlertService,
    private acmicService: AcmicService,
    private router: Router
  ) { }

  alertTypeObjects = [
    {
      "alertType":    "default",
      "className":    "default",
      "iconClass":    "fas fa-info-circle alert-icon icon-default"
    },
    {
      "alertType":    "error",
      "className":    "error",
      "iconClass":    "fas fa-times-circle alert-icon icon-error"
    },
    {
      "alertType":    "caution",
      "className":    "caution",
      "iconClass":    "fas fa-exclamation-triangle alert-icon icon-caution"
    },
    {
      "alertType":    "success",
      "className":    "success",
      "iconClass":    "fas fa-check-circle alert-icon icon-success"
    },
    {
      "alertType":    "renewal",
      "className":    "error",
      "iconClass":    "fas fa-times-circle alert-icon icon-error"
    },
    {
      "alertType":    "errorButton",
      "className":    "error",
      "iconClass":    "fas fa-times-circle alert-icon icon-error"
    },
    {
      "alertType":    "errorLink",
      "className":    "error",
      "iconClass":    "fas fa-times-circle alert-icon icon-error"
    }
  ];

  closeAlert(): void {
    if(this.message) this.alertService.clear();
  }

  closeMe(type): void {
    if (type == 'dynamic') {
      this.alertService.clear();
    }
    else if (type == 'static') {
      this.hide.emit(false);
    }
  }

  ngOnInit() {
    this.router.events.pipe(filter(event=> event instanceof NavigationEnd)).subscribe((event:NavigationEnd)=>{
      this.manageWallet = event.urlAfterRedirects.includes('wallet-details');
    })

    this.manageWallet = this.router.url.includes('wallet-details')
    if(this.acmicService.isACMIC()) {
      this.isAcmic = true;
      this.showWanringIcon = true;
    }
    this.alertService.getMessage().subscribe((message) => {
      this.message = message;
      this.closeFadeIn = true;
      this.closeFadeOut = false;

      if (!this.nonDynamic && message) {
        setTimeout( () => {
          this.setFadeOut = false;
        }, 500);     
      }
    });
  }
}
